import {ChangeEvent, ClipboardEvent} from 'react';
import {t} from '../../../common/getTranslations';
import {Button} from '../../../design-system/atoms/Button/Button';
import {InputField} from '../../../design-system/molecules/InputField/InputField';
import {HeaderTitle} from '../../../design-system/organisms/HeaderTitle/HeaderTitle';
import {RedeemDialog} from '../../../design-system/organisms/RedeemDialog/RedeemDialog';
import {TranslateKey} from '../../../locale/type';
import {LOG_CLICK_EVENT} from '../../../logging/logEvent';
import {Dialog, RedeemInfoList} from '../type';

export interface RedeemProps {
  isMobile: boolean;
  disabledRegisterButton: boolean;
  showDialog: boolean;
  redeemCode: string;
  redeemInfoList: RedeemInfoList;
  dialog?: Dialog;
  onChangeRedeemCode: (e: ChangeEvent<HTMLInputElement>) => void;
  onPasteRedeemCode: (e: ClipboardEvent<HTMLInputElement>) => void;
  onClickRemoveButton: () => void;
  onSubmitRedeemCode: (params: {isConfirmed?: boolean}) => Promise<void>;
  onCloseDialog: () => void;
  onClickSecondButton: () => void;
  onClickActiveButton: () => Promise<void>;
}

export const Redeem = ({
  isMobile,
  redeemCode,
  showDialog,
  dialog,
  disabledRegisterButton,
  redeemInfoList,
  onChangeRedeemCode,
  onPasteRedeemCode,
  onClickRemoveButton,
  onSubmitRedeemCode,
  onCloseDialog,
  onClickSecondButton,
  onClickActiveButton,
}: RedeemProps) => {
  return (
    <div className="min-h-screen px-15pxr">
      {!isMobile && (
        <HeaderTitle className="mt-20pxr mb-32pxr">
          {t('more_coupon_register')}
        </HeaderTitle>
      )}
      <div className="flex flex-col items-center py-30pxr">
        <InputField
          value={redeemCode}
          onChange={onChangeRedeemCode}
          onPaste={onPasteRedeemCode}
          onClickRemoveButton={onClickRemoveButton}
          placeholder={t('more_coupon_register_before_input')}
          isMobile={isMobile}
        />
        <Button
          disabled={disabledRegisterButton}
          onClick={e =>
            LOG_CLICK_EVENT('등록하기_클릭', e, () =>
              onSubmitRedeemCode({isConfirmed: false})
            )
          }
          className="mt-8pxr"
        >
          {t('more_coupon_register_button')}
        </Button>
      </div>
      <div>
        {redeemInfoList.map(({title, texts}, index) => (
          <div key={`info-${index}`} className="pt-12pxr pb-16pxr">
            <h4 className="font-small2-bold text-theme-solid-100">
              {t(title as TranslateKey) as string}
            </h4>
            <ul className="font-small2 list-inside list-none pt-4pxr text-theme-solid-60">
              {texts.map((_text, index) => (
                <li
                  key={`${_text}-${index}`}
                  className="whitespace-pre-line py-4pxr pl-8pxr -indent-6pxr before:mr-4pxr before:mt-6pxr before:inline-block
                before:h-2pxr before:w-2pxr before:rounded-full before:bg-theme-solid-60 before:align-text-top"
                >
                  {t(_text)}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <RedeemDialog
        closeDialog={onCloseDialog}
        isMobile={isMobile}
        showDialog={showDialog}
        dialog={dialog}
        onClickSecondButton={onClickSecondButton}
        onClickActiveButton={onClickActiveButton}
      />
    </div>
  );
};
